import { deleteUserColumnProfiles, updateUserColumnProfiles } from "../../apis/nontransactional";
import { API_RESPONSE_STATUS, BUSINESS_LAYER_RESPONSE, MANAGE_COLUMNS_VIEW_TYPES, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";

const _createUserColumnProfile = (objResp, arrColumnProfiles, activeWatchlistCopy, isUpdateCurrentWatchlist) => {
    let createdProfileResp = objResp?.data?.data;
    createdProfileResp?.columnDetails?.forEach((eachColumn) => {
        eachColumn.sSettings = JSON?.parse(eachColumn?.sSettings);
    });
    arrColumnProfiles?.push(createdProfileResp);
    let finalActiveWatchlist = {};
    if (isUpdateCurrentWatchlist) {
        activeWatchlistCopy['scrips'] = activeWatchlistCopy['scrips']?.map((scrip, i) => ({
            nMarketSegmentId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
            nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN],
            nSequenceNo: i + 1,
            sSettings: null
        }));
        let parsedsSettingsofWatchlist = JSON?.parse(activeWatchlistCopy.sSettings);
        finalActiveWatchlist = { ...activeWatchlistCopy, sSettings: JSON?.stringify({ ...parsedsSettingsofWatchlist, columnPofileId: objResp?.data?.data?.id }) };

    } else { }

    return { status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS, data: { arrColumnProfiles, createdProfileResp, finalActiveWatchlist } };
};


const _getUserColumnProfile = (arrColumnProfiles) => {

    try {
        arrColumnProfiles?.forEach((eahColumnProfile) => {
            eahColumnProfile?.columnDetails?.forEach((eachColumn) => {
                eachColumn.sSettings = JSON?.parse(eachColumn?.sSettings);
            });
        });




        const watchlistColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.WATCHLIST_VIEW_TYPE?.toLowerCase());
        const orderSingleScripColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SINGLE_SCRIP_VIEW_TYPE?.toLowerCase());
        const gtdColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_GOOD_TILL_DATE_VIEW_TYPE?.toLowerCase());
        const gttColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_GOOD_TILL_TRIGGER_VIEW_TYPE?.toLowerCase());
        const multilegColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_MULTI_LEG_VIEW_TYPE?.toLowerCase());
        const quitySipColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_EQUITY_SIP_VIEW_TYPE?.toLowerCase());
        const spreadColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SPREAD_VIEW_TYPE?.toLowerCase());
        const netPositionColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.NET_POSITION_VIEW_TYPE?.toLowerCase());
        const holdingsColumnProfiles = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.HOLDINGS_VIEW_TYPE?.toLowerCase());
        const futureColumnProfile = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.FUTURES_VIEW_TYPE?.toLowerCase());
        const constituentsColumnProfile = arrColumnProfiles?.filter(eachColumn => eachColumn?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.CONSTITUENTS_VIEW_TYPE?.toLowerCase());

        // updating watchlisting columnProfile
        const arrWatchlistColumnProfiles = watchlistColumnProfiles;
        // updating OrderSingleScrip columnProfile
        const objOrderSingleScripDefaultColumnProfile = orderSingleScripColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
        // updating GtdScrip columnProfile
        const objGtdDefaultColumnProfile = gtdColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
        // updating GtdScrip columnProfile
        const objGttDefaultColumnProfile = gttColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
        // updating MultiLegScrip columnProfile
        const objMultiLegDefaultColumnProfile = multilegColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
        // updating equitySipScrip columnProfile
        const objEquitySipDefaultColumnProfile = quitySipColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
        // updating SpreadScrip columnProfile
        const objSpreadDefaultColumnProfile = spreadColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
        // updating netPosition columnProfile
        const objNetPositionDefaultColumnProfile = netPositionColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
        // updating holdings columnProfile
        const objHoldingsDefaultColumnProfile = holdingsColumnProfiles?.find(eachColumn => eachColumn?.bIsDefault);
        // updating futures columnProfile
        const objFutureDefaultColumnProfile = futureColumnProfile?.find(eachColumn => eachColumn?.bIsDefault);
        // updating constituents columnProfile
        const objConstituentsDefaultColumnProfile = constituentsColumnProfile?.find(eachColumn => eachColumn?.bIsDefault);


        return {
            status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS,
            data: {
                arrColumnProfiles, arrWatchlistColumnProfiles, objOrderSingleScripDefaultColumnProfile, objGtdDefaultColumnProfile, objGttDefaultColumnProfile, objConstituentsDefaultColumnProfile, objFutureDefaultColumnProfile,
                objMultiLegDefaultColumnProfile, objEquitySipDefaultColumnProfile, objSpreadDefaultColumnProfile, objNetPositionDefaultColumnProfile, objHoldingsDefaultColumnProfile
            }
        };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
    }


};


const _deleteUserColumnProfile = async (userColumnProfiles, payload) => {
    try {
        const objResp = await deleteUserColumnProfiles(payload); // status response
        if (objResp?.data?.status === API_RESPONSE_STATUS.SUCCESS) {
            let arrColumnProfiles = userColumnProfiles?.filter(column => column?.id !== payload?.id); // data comes from parameters

            return {
                status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS,
                data: { arrColumnProfiles, objResp }
            };

        } else { }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
    }
};

const _updateUserColumnProfile = async (selectedProfile, arrColumnProfiles, activeWatchlistCopy, isUpdateCurrentWatchlist) => {
    try {
        //Ameersha - Start 
        delete selectedProfile.createdAt;
        delete selectedProfile.updatedAt;
        delete selectedProfile._lastChangedAt;
        //Ameersha - End
        // selectedProfile?.columnDetails?.forEach((eachColumn) => {
        //     if (typeof eachColumn.sSettings === 'string') {
        //     } else {
        //         eachColumn.sSettings = JSON?.stringify(eachColumn?.sSettings);
        //     }

        // });

        const objResp = await updateUserColumnProfiles(selectedProfile);
        if (objResp?.data?.status === API_RESPONSE_STATUS.SUCCESS) {

            let objRespProfile = objResp?.data?.data;

            objRespProfile?.columnDetails?.forEach((eachColumn) => {
                if (eachColumn.sSettings !== null) {
                    eachColumn.sSettings = JSON?.parse(eachColumn?.sSettings);
                } else {
                    eachColumn.sSettings = JSON?.parse(eachColumn?.sSettings);
                }
            });

            let nIndex = arrColumnProfiles?.findIndex((eachColum) => (eachColum?.id === objRespProfile?.id));
            if (nIndex >= 0) {
                arrColumnProfiles[nIndex] = objRespProfile;
                let finalActiveWatchlist = {};
                if (isUpdateCurrentWatchlist) {
                    activeWatchlistCopy['scrips'] = activeWatchlistCopy['scrips']?.map((scrip, i) => ({
                        nMarketSegmentId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                        nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                        nSequenceNo: i + 1,
                        sSettings: null
                    }));
                    let parsedsSettingsofWatchlist = JSON?.parse(activeWatchlistCopy.sSettings);
                    finalActiveWatchlist = { ...activeWatchlistCopy, sSettings: JSON?.stringify({ ...parsedsSettingsofWatchlist, columnPofileId: selectedProfile?.id }) };
                } else { }
                return {
                    status: true, message: BUSINESS_LAYER_RESPONSE?.SUCCESS,
                    data: { arrColumnProfiles, objResp, finalActiveWatchlist, objRespProfile }
                };

            } else { }

        } else {
            return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE };
        }
    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE?.FAILURE, error: error };
    }
};

export { _createUserColumnProfile, _deleteUserColumnProfile, _updateUserColumnProfile, _getUserColumnProfile };